import { Beneficiary } from '../types';
import getStatusName from './get-status-name';

import cn from '../styles.module.css';

const formatBeneficiariesList = (list: Beneficiary[]): Beneficiary[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const paymentTypeArray = result.paymentType.split('_');

    const paymentType = paymentTypeArray
      ?.map((type) => `${type.charAt(0)}${type.slice(1).toLocaleLowerCase()}`)
      .join(' ');

    const render: Record<string, React.JSX.Element> = {
      beneficiaryType: (
        <div>
          {result.beneficiaryType === 'INDIVIDUAL' ? 'Individual' : 'Company'}
        </div>
      ),
      paymentType: (
        <div>
          {`${paymentType} ${
            result.currencyId ? `(${result.currency?.name})` : ''
          }`}
        </div>
      ),
      iban: (
        <div className={cn.ibanRow}>
          {result.iban || result.bankAccountNumber}
        </div>
      ),
      countContracts: <div>{result.countContracts.count}</div>,
      status: <div>{getStatusName(result.status)}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatBeneficiariesList;
